import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const QUERY_KEY = `tag/search`;

export function useTagSearchQuery({
	enabled,
	query,
	sortDescriptor,
	expandTagAlert = true,
	impersonationContext,
}: {
	query: string;
	sortDescriptor?: Api.ISortDescriptor;
	expandTagAlert?: boolean;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [QUERY_KEY, query, sortDescriptor, expandTagAlert, impersonationContext],
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAccountTag[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tag/search`,
					queryParams: {
						query,
						sort: sortDescriptor?.sort,
						sortBy: sortDescriptor?.sortBy,
						expand: expandTagAlert ? 'TagAlert' : undefined,
					},
				}),
				'GET'
			);
		},
		enabled,
	});
}

export function invalidateAllTagSearchQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
}
